// extracted by mini-css-extract-plugin
export var chip = "_cw-0";
export var filterDropdown = "_cw-5";
export var filterItem = "_cw-6";
export var icon = "_cw-1";
export var removeButton = "_cw-3";
export var removeIcon = "_cw-4";
export var separator = "_cw-2";